var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('AlertBanner'),_c('router-view',{attrs:{"name":"sidebar"}}),_c('router-view',{attrs:{"name":"header"}}),_c('transition',{attrs:{"name":"router","mode":"out-in"}},[_c('router-view',{staticClass:"view router-view"})],1),_c('router-view',{attrs:{"name":"footer"}})],1):_c('Loader')
}
var staticRenderFns = []

export { render, staticRenderFns }